import { OnInit } from '@angular/core';
var AttachmentComponent = /** @class */ (function () {
    function AttachmentComponent() {
        this.endsWithMP4 = new RegExp('\.mp4$');
    }
    AttachmentComponent.prototype.ngOnInit = function () {
        this.fileType = this.getFileType();
        this.thumbnail = this.getThumbnail();
    };
    AttachmentComponent.prototype.getFileType = function () {
        var extension = this.getExtension().toLowerCase();
        if (extension === 'mp4') {
            return 'video';
        }
        if (['jpg', 'jpeg', 'png', 'jfif', 'heic', 'webp'].includes(extension)) {
            return 'image';
        }
        return 'other';
    };
    AttachmentComponent.prototype.getExtension = function () {
        var indexOfLastPoint = this.attachment.path.lastIndexOf('.');
        return this.attachment.path.substring(indexOfLastPoint + 1);
    };
    AttachmentComponent.prototype.getThumbnail = function () {
        if (this.endsWithMP4.test(this.attachment.path)) {
            return this.attachment.path.replace(this.endsWithMP4, '.jpg');
        }
        return this.attachment.path;
    };
    return AttachmentComponent;
}());
export { AttachmentComponent };
